import './App.css';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {routes} from './app-routes';
import {RecoilRoot} from 'recoil';

function App() {
    const router = createBrowserRouter(routes);
    const queryClient = new QueryClient();
    //alert('안녕')
    return (
        <QueryClientProvider client={queryClient}>
            <RecoilRoot>
                <RouterProvider router={router}/>
            </RecoilRoot>
        </QueryClientProvider>

    );
}

export default App;
